export const getModelUsuario = () => ({
    iIdUsuario: 0,
    iIdTipoCuenta: 1,
    iIdPerfil: 0,
});

export const getFormUsuario = () => ({
    txtNombres: {
        label: "Nombres:",
        required: true,
        value: "",
        error: false,
        message: "El nombre del usuario es requerido",
    },
    txtApellidoPaterno: {
        label: "Apellido paterno:",
        required: true,
        value: "",
        error: false,
        message: "El apellido paterno es requerido",
    },
    txtApellidoMaterno: {
        label: "Apellido materno:",
        required: false,
        value: "",
        error: false,
        message: "El apellido materno es requerido",
    },
    txtPerfil: {
        label: "Perfil:",
        required: true,
        value: "",
        error: false,
        message: "Seleccione el perfil del usuario",
    },
    txtTipoCuenta: {
        label: "Tipo de cuenta:",
        required: false,
        value: "",
        error: false,
        message: "Seleccione el tipo de cuenta",
    },
    txtFechaNacimiento: {
        label: "Fecha de nacimiento:",
        required: true,
        value: null,
        error: false,
        message: "La fecha de nacimiento es requerido",
    },
    txtTelefono: {
        label: "Teléfono:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un número válido de 10 dígitos",
    },
    txtCorreoElectronico: {
        label: "Correo electrónico:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un correo válido",
    },
    txtDomicilio: {
        label: "Domicilio:",
        required: false,
        value: "",
        error: false,
        message: "El domicilio del usuario es requerido",
    },
    txtUsuario: {
        label: "Nombre de acceso:",
        required: true,
        value: "",
        error: false,
        message: "El nombre de usuario es requerido",
    },
    txtPassword: {
        label: "Contraseña:",
        required: true,
        value: "",
        error: false,
        message: "La contraseña del usuario es requerida",
    },
    txtAcceso: {
        label: "Acceso:",
        required: true,
        value: true,
        error: false,
        message: "Dar permisos de acceso al Portal Meditoc CallCenter",
    },
});

export const getUsuarioColumns = () => [
    { title: "ID", field: "iIdUsuario" },
    { title: "Usuario", field: "sUsuario" },
    { title: "Tipo de cuenta", field: "sTipoCuenta" },
    { title: "Perfil", field: "sPerfil" },
    { title: "Registrado", field: "sFechaCreacion" },
];
